const baseUrl =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_API_URL_PRODUCT
    : process.env.REACT_APP_API_URL_DEBUG;

export const getData = async (endpoint, authen = false) => {
  return request(
    endpoint,
    "GET",
    null,
    authen ? localStorage.getItem("token") : null
  );
};

export const postData = async (endpoint, authen = false, data = null) => {
  return request(
    endpoint,
    "POST",
    data,
    authen ? localStorage.getItem("token") : null
  );
};

async function request(endpoint, method, data = null, authen = null) {
  const url = `${baseUrl}${endpoint}`;
  const options = {
    method,
    headers: {
      "Content-Type": "application/json",
    },
  };

  if (authen) {
    options.headers["authorization"] = authen;
  }

  if (data) {
    options.body = JSON.stringify(data);
  }

  try {
    const response = await fetch(url, options);
    if (!response.ok) {
      const text = await response.text();
      if (
        ["Failed to authenticate token", "No token provided"].includes(text)
      ) {
        localStorage.removeItem("token");
        window.location.href = "/authen";
      } else {
        throw new Error(text);
      }
    }
    return await response.json();
  } catch (error) {
    console.error("Fetch API error: ", error);
    throw error;
  }
}
